export const galleryImages = [
  {
    rows: 1,
    cols: 1,
    src: "Sources/images/gallery/2.png",
  },

  {
    rows: 1,
    cols: 1,
    src: "Sources/images/milestone/12.png",
  },
  {
    rows: 1,
    cols: 1,
    src: "Sources/images/milestone/1.png",
  },
  {
    rows: 1,
    cols: 1,
    src: "Sources/images/milestone/11.png",
  },
  {
    rows: 1,
    cols: 1,
    src: "Sources/images/gallery/main/1.png",
  },
  {
    rows: 1,
    cols: 1,
    src: "Sources/images/gallery/main/2.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/gallery/main/landscape/1.png",
  },
  {
    rows: 1,
    cols: 1,
    src: "Sources/images/gallery/main/3.png",
  },
  {
    rows: 1,
    cols: 1,
    src: "Sources/images/gallery/main/4.png",
  },
  {
    rows: 1,
    cols: 1,
    src: "Sources/images/gallery/main/5.png",
  },
  {
    rows: 1,
    cols: 1,
    src: "Sources/images/gallery/main/6.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/gallery/main/landscape/2.png",
  },
  {
    rows: 1,
    cols: 1,
    src: "Sources/images/gallery/main/7.png",
  },
  {
    rows: 1,
    cols: 1,
    src: "Sources/images/gallery/main/8.png",
  },
  {
    rows: 1,
    cols: 1,
    src: "Sources/images/gallery/main/9.png",
  },
  {
    rows: 1,
    cols: 1,
    src: "Sources/images/gallery/main/10.png",
  },
  {
    rows: 2,
    cols: 2,
    src: "Sources/images/gallery/main/big/1.png",
  },
  {
    rows: 1,
    cols: 1,
    src: "Sources/images/gallery/main/11.png",
  },
  {
    rows: 1,
    cols: 1,
    src: "Sources/images/milestone/5.png",
  },
  {
    rows: 1,
    cols: 1,
    src: "Sources/images/milestone/1.png",
  },
  {
    rows: 1,
    cols: 1,
    src: "Sources/images/gallery/3.png",
  },
  {
    rows: 1,
    cols: 1,
    src: "Sources/images/milestone/7.png",
  },
  {
    rows: 1,
    cols: 1,
    src: "Sources/images/gallery/9.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/commercial/completed/1.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/commercial/completed/2.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/commercial/completed/3.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/commercial/completed/4.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/commercial/completed/5.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/commercial/completed/6.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/commercial/completed/7.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/commercial/completed/8.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/commercial/completed/9.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/commercial/completed/10.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/commercial/completed/11.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/commercial/completed/12.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/commercial/ongoing/1.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/commercial/ongoing/2.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/commercial/ongoing/3.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/commercial/ongoing/4.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/commercial/ongoing/5.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/commercial/ongoing/6.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/industrial/completed/1.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/industrial/completed/2.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/industrial/completed/3.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/industrial/completed/4.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/industrial/completed/5.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/industrial/completed/6.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/industrial/completed/7.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/industrial/completed/8.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/industrial/completed/9.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/industrial/completed/10.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/industrial/completed/11.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/industrial/completed/12.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/industrial/completed/13.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/industrial/completed/14.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/industrial/completed/15.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/industrial/completed/16.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/Institutional_projects/completed/1.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/Institutional_projects/completed/2.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/Institutional_projects/completed/3.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/Institutional_projects/completed/4.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/Institutional_projects/ongoing/1.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/Institutional_projects/ongoing/2.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/residential/completed/1.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/residential/completed/2.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/residential/completed/3.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/residential/completed/4.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/residential/completed/5.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/residential/completed/6.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/residential/completed/7.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/residential/completed/8.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/residential/completed/9.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/residential/completed/10.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/residential/completed/11.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/residential/ongoing/1.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/residential/ongoing/2.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/residential/ongoing/3.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/residential/ongoing/4.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/residential/ongoing/5.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/residential/ongoing/6.png",
  },
  {
    rows: 1,
    cols: 2,
    src: "Sources/images/prouctlist/residential/ongoing/7.png",
  },
];
